import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import { useMemo } from "react";

const useApiService = (): AxiosInstance => {
  const { getIdTokenClaims, logout } = useAuth0();

  const api = useMemo(() => {
    const instance = axios.create({
      baseURL: import.meta.env.VITE_API_URL,
      headers: {
        "Content-Type": "application/json",
      },
    });

    instance.interceptors.request.use(
      async (config: InternalAxiosRequestConfig) => {
        try {
          const tokenClaims = await getIdTokenClaims();

          if (!tokenClaims?.__raw) {
            // FIX: Removed the 'logoutParams' wrapper
            logout({ returnTo: window.location.origin });
            return Promise.reject(new Error("No token available"));
          }

          config.headers = config.headers || {};
          config.headers.Authorization = `Bearer ${tokenClaims.__raw}`;
          return config;
        } catch (error) {
          // FIX: Removed the 'logoutParams' wrapper
          logout({ returnTo: window.location.origin });
          return Promise.reject(error);
        }
      },
      (error) => {
        return Promise.reject(error);
      },
    );

    return instance;
  }, [getIdTokenClaims, logout]);

  return api;
};

export default useApiService;